import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import moment from "moment-timezone";
import { Row, Col } from "react-bootstrap";
import Button1 from "react-bootstrap-button-loader";
import Button from "react-bootstrap/Button";
import DayPicker, { DateUtils } from "react-day-picker";
import Helmet from "react-helmet";
import { analyticsUpdateDateProps } from "AnalyticscommonActions";
import { fetchsponengagementbBarChart } from "SponsorinsightActions";
import { fetchexhiengagementbBarChart } from "ExhibitorinsightActions";
import { attendeesmessagingMsgengmntbarchart } from "AttendeesmessagingCommunicationAction";
import { fetchAttnNetwrkEngaBarChart } from "AttendeesnetworkActions";
import { fetchspkrengagementbBarChart } from "SpeakeranalyticActions";
// Need
// import {
//   arrangeDataWeekly,
//   arrangeDataMonthly,
// } from "AnalyticscommonAnalyticscommonindex";
import { fetchAttendengagementbBarChart } from "DashboardActions"; //
import { DATE_FORMAT } from "Constants";
import LocaleStrings from "Languages";

class AnalyticsCommonHeader extends Component {
  static defaultProps = {
    numberOfMonths: 2,
  };
  constructor(props) {
    super(props);

    this.handleDayClick = this.handleDayClick.bind(this);
    this.handleResetClick = this.handleResetClick.bind(this);
    this.state = this.getInitialState();
  }

  componentDidMount() {
    this.props.analyticsUpdateDateProps(this.getInitialDate());
  }

  componentWillUnmount() {
    // this.props.dateProps.from = null;
    // this.props.dateProps.to = null;
    // this.props.analyticsUpdateDateProps(this.props.dateProps);

    this.props.analyticsUpdateDateProps(this.getInitialDate());
  }

  getInitialDate() {
    return {
      from: moment().subtract(6, "d").format(DATE_FORMAT),
      to: moment().format(DATE_FORMAT),
      enteredTo: null,
    };
  }

  // Intialstate
  getInitialState() {
    return {
      from: moment().subtract(6, "day").endOf("day").toDate(),
      to: moment().toDate(),
      showPicker: false,
    };
  }

  isSelectingFirstDay(from, to, day) {
    const isBeforeFirstDay = from && DateUtils.isDayBefore(day, from);
    const isRangeSelected = from && to;
    return !from || isBeforeFirstDay || isRangeSelected;
  }

  handleDayClick(day) {
    // const range = DateUtils.addDayToRange(day, this.state);
    // this.setState(range);
    var { from, to } = this.state;
    var from1 = from;
    var to1 = to;

    if (this.isSelectingFirstDay(from, to, day)) {
      from1 = day;
      to1 = null;

      this.setState({ from: day, to: null });
    } else {
      from1 = from;
      to1 = day;

      this.setState({
        from: from,
        to: day,
      });
    }

    // console.log("from1 :- ", from1);
    // console.log("to1 :- ", to1);

    if (from1 && to1) {
      // Toggle Calendar
      this.toggleCalendar();

      var myFromdate = moment(from1).format(DATE_FORMAT);
      var myUptodate = moment(to1).format(DATE_FORMAT);

      this.props.dateProps.from = myFromdate;
      this.props.dateProps.to = myUptodate;

      this.props.analyticsUpdateDateProps(this.props.dateProps);

      if (this.props.callFrom == "Sponsors Insights") {
        // Top sponsors ( engagement bar chart)
        this.props.fetchsponengagementbBarChart(
          this.props.session,
          this.props.dateProps,
          (fetchsponengagementbbarchartResponse) => {
            if (fetchsponengagementbbarchartResponse.error === 0) {
              // var e = document.getElementById(
              //   "sponsorsEngagementOptionChangeID"
              // ); // Get bar chart selected option val
              // var value = e.options[e.selectedIndex].value;
              // var text = e.options[e.selectedIndex].text;
              this.props.xchart();

              this.setState({ loading: false });
            }
          }
        );
      } // Call from tab name
      else if (this.props.callFrom == "Exhibitors Insights") {
        this.props.fetchexhiengagementbBarChart(
          this.props.session,
          this.props.dateProps,
          (fetchexhiengagementbbarchartResponse) => {
            if (fetchexhiengagementbbarchartResponse.error === 0) {
              this.props.xchart();

              this.setState({ loading: false });
            }
          }
        );
      } else if (this.props.callFrom == "Attendees Messaging") {
        this.props.attendeesmessagingMsgengmntbarchart(
          this.props.session,
          this.props.dateProps,
          (attendeesmessagingmsgengmntbarchartResponse) => {
            if (attendeesmessagingmsgengmntbarchartResponse.error === 0) {
              this.props.xchart();

              this.setState({ loading: false });
            }
          }
        );
      } else if (this.props.callFrom == "Attendees Network") {
        this.props.fetchAttnNetwrkEngaBarChart(
          this.props.session,
          this.props.dateProps,
          (fetchattnnetwrkengabarchartResponse) => {
            if (fetchattnnetwrkengabarchartResponse.error === 0) {
              this.props.xchart();

              this.setState({ loading: false });
            }
          }
        );
      } else if (this.props.callFrom == "Speakers") {
        this.props.fetchspkrengagementbBarChart(
          this.props.session,
          this.props.dateProps,
          (fetchspkrengagementbbarchartResponse) => {
            if (fetchspkrengagementbbarchartResponse.error === 0) {
              this.props.xchart();

              this.setState({ loading: false });
            }
          }
        );
      } else if (this.props.callFrom == "Dashboard") {
        this.props.fetchAttendengagementbBarChart(
          this.props.session,
          this.props.dateProps,
          (fetchattendengagementbbarchartResponse) => {
            if (fetchattendengagementbbarchartResponse.error === 0) {
              this.props.xchart();

              this.setState({ loading: false });
            }
          }
        );
      }
    }
  }

  handleResetClick() {
    this.setState(this.getInitialState());
    this.props.dateProps.from = null;
    this.props.dateProps.to = null;
    this.props.analyticsUpdateDateProps(this.props.dateProps);
    // Reset click Get default value
    if (this.props.callFrom == "Sponsors Insights") {
      // Top sponsors ( engagement bar chart)
      this.props.fetchsponengagementbBarChart(
        this.props.session,
        this.props.dateProps,
        (fetchsponengagementbbarchartResponse) => {
          if (fetchsponengagementbbarchartResponse.error === 0) {
            // var e = document.getElementById("sponsorsEngagementOptionChangeID"); // Get bar chart selected option val
            // var value = e.options[e.selectedIndex].value;
            // var text = e.options[e.selectedIndex].text;
            this.props.xchart();

            this.setState({ loading: false });
          }
        }
      );
    } // Call from tab name
    else if (this.props.callFrom == "Exhibitors Insights") {
      this.props.fetchexhiengagementbBarChart(
        this.props.session,
        this.props.dateProps,
        (fetchexhiengagementbbarchartResponse) => {
          if (fetchexhiengagementbbarchartResponse.error === 0) {
            this.props.xchart();

            this.setState({ loading: false });
          }
        }
      );
    } else if (this.props.callFrom == "Attendees Messaging") {
      this.props.attendeesmessagingMsgengmntbarchart(
        this.props.session,
        this.props.dateProps,
        (attendeesmessagingmsgengmntbarchartResponse) => {
          if (attendeesmessagingmsgengmntbarchartResponse.error === 0) {
            this.props.xchart();

            this.setState({ loading: false });
          }
        }
      );
    } else if (this.props.callFrom == "Attendees Network") {
      this.props.fetchAttnNetwrkEngaBarChart(
        this.props.session,
        this.props.dateProps,
        (fetchattnnetwrkengabarchartResponse) => {
          if (fetchattnnetwrkengabarchartResponse.error === 0) {
            this.props.xchart();

            this.setState({ loading: false });
          }
        }
      );
    } else if (this.props.callFrom == "Speakers") {
      this.props.fetchspkrengagementbBarChart(
        this.props.session,
        this.props.dateProps,
        (fetchspkrengagementbbarchartResponse) => {
          if (fetchspkrengagementbbarchartResponse.error === 0) {
            this.props.xchart();

            this.setState({ loading: false });
          }
        }
      );
    } else if (this.props.callFrom == "Dashboard") {
      this.props.fetchAttendengagementbBarChart(
        this.props.session,
        this.props.dateProps,
        (fetchattendengagementbbarchartResponse) => {
          if (fetchattendengagementbbarchartResponse.error === 0) {
            this.props.xchart();

            this.setState({ loading: false });
          }
        }
      );
    }
  }

  toggleCalendar = () => {
    if (!this.state.showPicker) {
      document.addEventListener("click", this.handleOutsideClick, false);
    } else {
      document.removeEventListener("click", this.handleOutsideClick, false);
    }

    this.setState((prevState) => ({
      showPicker: !prevState.showPicker,
    }));
  };

  handleOutsideClick = (e) => {
    //if (!this.node.contains(e.target)) this.toggleCalendar();
  };

  // on click each page refresh
  refreshAnalytics = () => {
    this.setState(this.getInitialState());
    this.props.dateProps.from = null;
    this.props.dateProps.to = null;
    this.props.analyticsUpdateDateProps(this.props.dateProps);

    this.props.finishOperationsCallback();
  };

  handleExport = () => {
    this.props.exportData();
  };

  render() {
    const { from, to } = this.state;
    const modifiers = { start: from, end: to };
    // console.log("this.props.loading :- ", this.props.loading);

    return (
      <>
        <div className="content-header-bar">
          <div className="pull-left h-100 vertical-align-center">
            <div className="content-icon-div"></div>
          </div>
          <div className="pull-right h-100 vertical-align-center">
            <ul className="header-buttons vertical-align-center">
              {this.props.callFrom === "Dashboard" ? (
                <li>
                  <Button1
                    type="button"
                    className="btn-custom-blue"
                    onClick={this.handleExport}
                    loading={this.props.loading}
                  >
                    {LocaleStrings.button_csv_export}
                  </Button1>
                </li>
              ) : (
                ""
              )}
              <li>
                <Button
                  type="button"
                  className="extra-button-theme btn-custom-white"
                  onClick={this.refreshAnalytics}
                  style={{ fontSize: 11 }}
                  title="Press Me"
                >
                  <i className="fa fa-refresh" aria-hidden="true"></i>
                </Button>
              </li>
              {this.props.callFrom != "socialfeed" &&
              this.props.callFrom != "session" &&
              this.props.callFrom != "Advertisement Insights" ? (
                <li>
                  {this.state.showPicker ? (
                    <button
                      className="i-custom-table-delete"
                      onClick={this.toggleCalendar}
                    >
                      <img
                        className="i-custom-table"
                        src="../../style/images/custom-icons/shape-1317-copy-3.svg"
                      />
                    </button>
                  ) : (
                    <Button
                      id="analytics_datepicket_btn"
                      variant={this.state.showPicker ? "danger" : "primary"}
                      onClick={this.toggleCalendar}
                    >
                      <i
                        className={
                          this.state.showPicker
                            ? "fa fa-times"
                            : "fa fa-calendar"
                        }
                      ></i>
                    </Button>
                  )}{" "}
                </li>
              ) : (
                ""
              )}
              {this.props.callFrom != "socialfeed" &&
              this.props.callFrom != "session" &&
              this.props.callFrom != "Advertisement Insights" ? (
                <li>
                  <div>
                    <div
                      style={{
                        color: "#2676ea",
                        fontWeight: "bold",
                        display: "inline-block",
                      }}
                    >
                      {from ? from.toLocaleDateString() : ""}
                    </div>
                    <div style={{ display: "inline-block", margin: "5px" }}>
                      {" "}
                      ➔{" "}
                    </div>
                    <div
                      style={{
                        color: "#2676ea",
                        fontWeight: "bold",
                        display: "inline-block",
                      }}
                    >
                      {to ? to.toLocaleDateString() : ""}
                    </div>
                  </div>
                </li>
              ) : (
                ""
              )}
              <li
                ref={(node) => {
                  this.node = node;
                }}
              >
                <div>
                  {this.state.showPicker ? (
                    <div className="RangeExample">
                      {!from && !to && "Please select the first day."}
                      {from && !to && "Please select the last day."}
                      {from && to && (
                        // ` ${from.toLocaleDateString()} to
                        //     ${to.toLocaleDateString()}`

                        <Row className="vertical-align-center">
                          <Col md={3}>
                            {" "}
                            {from && to && (
                              <button
                                className="link extra-button-theme btn-custom-white"
                                onClick={this.handleResetClick}
                              >
                                {LocaleStrings.reset}
                              </button>
                            )}
                          </Col>
                        </Row>
                      )}

                      <DayPicker
                        className="Selectable"
                        numberOfMonths={this.props.numberOfMonths}
                        selectedDays={[from, { from, to }]}
                        modifiers={modifiers}
                        onDayClick={this.handleDayClick}
                        // shouldCloseOnSelect={true}
                        onChange={(value) => {
                          this.refs.timePicker.cancelFocusInput();
                        }}
                      />
                      <Helmet>
                        <style>{`
                                  .Selectable .DayPicker-Day--selected:not(.DayPicker-Day--start):not(.DayPicker-Day--end):not(.DayPicker-Day--outside) {
                                    background-color: #f0f8ff !important;
                                    color: #4a90e2;
                                  }
                                  .Selectable .DayPicker-Day {
                                    border-radius: 0 !important;
                                  }
                                  .Selectable .DayPicker-Day--start {
                                    border-top-left-radius: 50% !important;
                                    border-bottom-left-radius: 50% !important;
                                  }
                                  .Selectable .DayPicker-Day--end {
                                    border-top-right-radius: 50% !important;
                                    border-bottom-right-radius: 50% !important;
                                  }
                                `}</style>
                      </Helmet>
                    </div>
                  ) : null}
                </div>
              </li>
            </ul>
          </div>
        </div>

        <Helmet>
          <style>{`
              .Range .DayPicker-Day--selected:not(.DayPicker-Day--start):not(.DayPicker-Day--end):not(.DayPicker-Day--outside) {
                background-color: #f0f8ff !important;
                color: #4a90e2;
              }
              .Range .DayPicker-Day {
                border-radius: 0 !important;
              }
              .DayPicker {
                right:1px;  
                width:560px;
                display: block;
                font-size: 1.5rem;
                position: absolute;
                background: white;
                z-index: 1000;
                margin-top: 35px;
                border-radius: 10px;
                -webkit-box-shadow: 0 1px 15px 1px rgba(40,72,229,.2)!important;
                box-shadow: 0 1px 15px 1px rgba(40,72,229,.2)!important;
              }
              .Selectable .DayPicker-Day--selected:not(.DayPicker-Day--start):not(.DayPicker-Day--end):not(.DayPicker-Day--outside) {
                background-color: #f0f8ff !important;
                color: #4a90e2;
              }
              .Selectable .DayPicker-Day {
                border-radius: 0 !important;
              }
              .Selectable .DayPicker-Day--start {
                border-top-left-radius: 50% !important;
                border-bottom-left-radius: 50% !important;
              }
              .Selectable .DayPicker-Day--end {
                border-top-right-radius: 50% !important;
                border-bottom-right-radius: 50% !important;
              }
              .DayPicker-Day--highlighted{
                color:#4da1ff;
                font-weight:bold;

              }
          `}</style>
        </Helmet>
      </>
    );
  }
}

//export default AnalyticsCommonHeader;

function mapStateToProps(state) {
  var { session, user, sponsorInsightMenu, sponsorsinsightSelectedItem } =
    state;
  //

  var sopnbarchartInner = state.sponsorsinsightengagementbarChart
    ? state.sponsorsinsightengagementbarChart.response
    : [];

  return {
    session,
    user,
    deviceSize: state.deviceSize,
    sponsorInsightMenu,
    sponsorsinsightSelectedItem,
    dateProps: state.analyticscommondatepropsreducer,
    sopnbarchartInner,
  };
}

// Export with connect
export default connect(mapStateToProps, {
  analyticsUpdateDateProps,
  fetchsponengagementbBarChart,
  fetchexhiengagementbBarChart,
  attendeesmessagingMsgengmntbarchart,
  fetchAttnNetwrkEngaBarChart,
  fetchspkrengagementbBarChart,
  fetchAttendengagementbBarChart,
})(AnalyticsCommonHeader);
